import { withBase } from '../../lib/with-base.js';

/**
 * Base class.
 */
export class Base extends withBase(HTMLElement) {}
